import React from 'react';

// --- ICONS (using simple inline SVG for minimalism) ---
const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-1 transition-transform group-hover:rotate-180">
    <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
  </svg>
);

// --- 1. HEADER / NAVIGATION ---
// const Header = () => {
//   return (
//     <>
//       {/* Preview Branch Banner */}
//       {/* <div id="preview-banner" className="text-center bg-gray-100 text-black py-1 text-xs sm:text-sm font-mono">
//         🚧 PREVIEW BRANCH: main 🚧
//       </div> */}
//       {/* Main Header */}
//       <header id="main-header" className="sticky top-0 bg-white bg-opacity-80 backdrop-blur-md border-b border-gray-200 z-50">
//         {/* <div id="header-container" className="container mx-auto px-6 py-4 flex justify-between items-center">
//           <div id="logo" className="text-2xl font-bold text-black cursor-pointer">DeepDocs AI</div>
//           <nav id="main-navigation" className="hidden md:flex items-center space-x-8">
//             <a href="#solutions" className="text-black hover:text-gray-600 flex items-center group">Solutions <ChevronDown /></a>
//             <a href="#industries" className="text-black hover:text-gray-600 flex items-center group">Industries <ChevronDown /></a>
//             <a href="#clients" className="text-black hover:text-gray-600">Clients</a>
//             <a href="#about" className="text-black hover:text-gray-600">About</a>
//           </nav>
//           <button id="demo-button-desktop" className="hidden md:block bg-black text-white px-5 py-2.5 font-semibold hover:bg-gray-800 transition-colors rounded-md text-sm">
//             Book Demo • Limited Slots
//           </button>
//           <button id="mobile-menu-button" className="md:hidden text-black">
//              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
//             </svg>
//           </button>
//         </div> */}
//       </header>
//     </>
//   );
// };

// --- 2. HERO SECTION ---
const Hero = () => {
  return (
    <section id="hero-section" className="bg-black text-white">
      <div id="hero-container" className="container mx-auto px-6 py-24 sm:py-32 md:py-40 text-center">
        <h1 id="hero-title" className="text-4xl sm:text-5xl md:text-7xl font-extrabold leading-tight tracking-tighter">Go faster. Think deeper. Do better.</h1>
        <p id="hero-subtitle" className="mt-6 max-w-2xl mx-auto text-lg sm:text-xl text-gray-300">A High Precision Framework for Healthcare & Life Sciences</p>
        <div id="hero-buttons" className="mt-10 flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <button id="hero-demo-button" className="w-full sm:w-auto bg-white text-black px-8 py-3 font-semibold hover:bg-gray-200 transition-colors rounded-md">
            Get demo
          </button>
          <button id="hero-learn-button" className="w-full sm:w-auto border border-gray-600 text-white px-8 py-3 font-semibold hover:bg-white hover:text-black transition-colors rounded-md">
            Learn more
          </button>
        </div>
      </div>
    </section>
  );
};

// --- 3. LOGO CAROUSEL SECTION ---
const LogoCarousel = () => {
  const brands = ["Brand One", "Brand Two", "Brand Three", "Brand Four", "Brand Five", "Brand Six"];
  return (
    <section id="logo-carousel-section" className="bg-white py-12">
      <div id="logo-carousel-container" className="container mx-auto px-6 text-center">
        <p id="logo-carousel-title" className="text-gray-500 mb-8 tracking-widest uppercase text-sm">Trusted by leading companies</p>
        <div id="logo-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {brands.map((brand, index) => (
            <div key={index} id={`logo-item-${index}`} className="flex justify-center items-center">
              <span className="text-2xl font-bold text-gray-300 select-none">{brand}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// --- 4. STATS SECTION ---
const Stats = () => {
  const stats = [
    { value: "0%", label: "Hallucination rate" },
    { value: "100%", label: "Data privacy" },
    { value: "25+", label: "Languages supported" },
    { value: "150+", label: "Clinical experts using" },
  ];
  return (
    <section id="stats-section" className="bg-gray-50 py-20">
      <div id="stats-container" className="container mx-auto px-6">
        <div id="stats-grid" className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat, index) => (
            <div key={index} id={`stat-item-${index}`}>
              <p id={`stat-value-${index}`} className="text-4xl sm:text-5xl font-bold text-black">{stat.value}</p>
              <p id={`stat-label-${index}`} className="mt-2 text-gray-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// --- 5. AI FACTORIES SECTION ---
const FactoryCard = ({ title, description, features, highlight, imageSide = 'right', index }) => {
  const textContent = (
    <div id={`factory-text-${index}`} className="md:w-1/2 flex flex-col justify-center">
      <h3 id={`factory-title-${index}`} className="text-3xl font-bold mb-4">{title}</h3>
      <p id={`factory-description-${index}`} className="text-gray-600 mb-6">{description}</p>
      <ul id={`factory-features-${index}`} className="space-y-3 mb-6">
        {features.map((feature, featureIndex) => (
          <li key={featureIndex} id={`factory-feature-${index}-${featureIndex}`} className="flex items-start">
            <span className="text-black mr-3 mt-1">✓</span>
            <span className="text-gray-800">{feature}</span>
          </li>
        ))}
      </ul>
      <div id={`factory-highlight-${index}`} className="bg-gray-50 border border-gray-200 p-4 mt-4 rounded-md">
        <p className="font-semibold text-black">{highlight}</p>
      </div>
    </div>
  );

  const imageContent = (
    <div id={`factory-image-container-${index}`} className="md:w-1/2 flex items-center justify-center p-8 mt-8 md:mt-0">
      <div id={`factory-image-${index}`} className="w-full h-80 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg"></div>
    </div>
  );

  return (
    <div id={`factory-card-${index}`} className={`flex flex-col md:flex-row items-center gap-12 ${imageSide === 'left' ? 'md:flex-row-reverse' : ''}`}>
      {textContent}
      {imageContent}
    </div>
  );
};

const AIFactories = () => {
  const factories = [
    { title: "Clinical Affairs", description: "Literature analysis, evidence synthesis, and clinical evaluation.", features: ["Dam Select - Automated study selection", "Dam Assess - Quality assessment", "Dam Extract - Data extraction", "DeepWrite SR - Report generation"], highlight: "From literature search to regulatory-grade report", imageSide: 'right' },
    { title: "Clinical Investigation", description: "Clinical study reports, protocol analysis, and data extraction.", features: ["Dam Extract - Multi-format data extraction", "DeepTemplate - Protocol compliance check"], highlight: "Streamline clinical data processing workflows", imageSide: 'left' },
    { title: "Regulatory Affairs", description: "Document comparison, template filling, and compliance reports.", features: ["DeepCompare - Document version control", "DeepTemplate - Automated form filling", "Dam Extract - Regulatory data mining"], highlight: "Ensure compliance across all submissions", imageSide: 'right' },
    { title: "Medical Writing", description: "Scientific publication, medical communication, and document creation.", features: ["DeepWrite - Scientific manuscript drafting", "Dam Extract - Reference compilation", "DeepTemplate - Journal submission formatting"], highlight: "Accelerate publication-ready content creation", imageSide: 'left' },
  ];

  return (
    <section id="ai-factories-section" className="bg-white py-20 sm:py-24">
      <div id="ai-factories-container" className="container mx-auto px-6">
        <div id="ai-factories-header" className="text-center mb-16">
          <h2 id="ai-factories-title" className="text-4xl font-bold text-black">Purpose-built AI Factories for Expert Teams</h2>
          <p id="ai-factories-subtitle" className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">Stop using generic AI tools. Get specialized workflows designed for regulatory compliance.</p>
        </div>
        <div id="ai-factories-list" className="space-y-24">
          {factories.map((factory, index) => <FactoryCard key={index} {...factory} index={index} />)}
        </div>
      </div>
    </section>
  );
};

// --- 6. FEATURES SECTION ---
const Features = () => {
  const features = [
    { title: "Document intelligence", description: "Purpose-built for medical literature, clinical evaluation reports, and regulatory submissions with complete audit trails." },
    { title: "Privacy by design", description: "Your clinical data never leaves your infrastructure. Deploy on-premise, in private clouds, or air-gapped environments." },
    { title: "Global compliance", description: "Process regulatory documents in 25+ languages with understanding of cultural nuances and local regulations." },
    { title: "Observable workflows", description: "Complete transparency in every processing step. Real-time monitoring and full traceability for compliance requirements." },
    { title: "High valuable tasks", description: "Extract complex data from documents - tables, charts, handwritten notes, and multi-column layouts." },
    { title: "High performance metrics", description: "Revolutionary approach ensures factual outputs through source verification, cross-referencing, and confidence scoring." },
  ];
  return (
    <section id="features-section" className="bg-gray-50 py-20 sm:py-24">
      <div id="features-container" className="container mx-auto px-6">
        <div id="features-header" className="text-center mb-12">
          <h2 id="features-title" className="text-4xl font-bold text-black">Built for clinical excellence</h2>
        </div>
        <div id="features-grid" className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} id={`feature-card-${index}`} className="bg-white p-6 border border-gray-200 rounded-lg">
              <h3 id={`feature-title-${index}`} className="text-xl font-bold mb-3">{feature.title}</h3>
              <p id={`feature-description-${index}`} className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// --- 7. TESTIMONIALS SECTION ---
const Testimonials = () => {
  const testimonials = [
    { quote: "It's impressive the precision of what you can do and how easily you can automate with Deepdocs AI.", author: "Clinical trials manager", company: "Swiss Medical Device Company", borderColor: "border-gray-800" },
    { quote: "The team have spoken highly of your product, and we are very pleased to be able to use DeepDocs AI.", author: "CEO", company: "American Medical Devices Corporation", borderColor: "border-gray-600" },
    { quote: "It's really powerful... DeepDocs AI assist our experts and save them precious time.", author: "Scientific director", company: "French CRO", borderColor: "border-gray-500" },
    { quote: "Using Deepdocs has saved me at least 50% of my time, allowing me to refocus on other projects.", author: "Medical writer", company: "French Bariatric Medical Devices Corp", borderColor: "border-gray-400" },
  ];
  return (
    <section id="testimonials-section" className="bg-white py-20 sm:py-24">
      <div id="testimonials-container" className="container mx-auto px-6">
        <div id="testimonials-header" className="text-center mb-12">
          <h2 id="testimonials-title" className="text-4xl font-bold text-black">Our partners talk highly of us</h2>
        </div>
        <div id="testimonials-grid" className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} id={`testimonial-card-${index}`} className={`bg-white p-6 border-l-4 ${testimonial.borderColor} border border-gray-200 rounded-r-lg`}>
              <p id={`testimonial-quote-${index}`} className="text-gray-800 italic mb-4">"{testimonial.quote}"</p>
              <p id={`testimonial-author-${index}`} className="font-semibold text-black">{testimonial.author}</p>
              <p id={`testimonial-company-${index}`} className="text-gray-500 text-sm">{testimonial.company}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// --- 8. ROI CALCULATOR (PLACEHOLDER) ---
const ROICalculator = () => {
    return (
        <section id="roi-calculator-section" className="bg-gray-50 py-20 sm:py-24">
            <div id="roi-calculator-container" className="container mx-auto px-6 text-center">
                 <h2 id="roi-calculator-title" className="text-3xl font-bold text-gray-400">ROI Calculator Section</h2>
                 <p id="roi-calculator-subtitle" className="text-gray-500 mt-2">Coming soon...</p>
            </div>
        </section>
    );
};

// --- 9. SOCIAL PROOF SECTION ---
const SocialProof = () => {
  return (
    <section id="social-proof-section" className="bg-white py-20 sm:py-24">
        <div id="social-proof-container" className="container mx-auto px-6">
            <div id="social-proof-card" className="max-w-3xl mx-auto text-center bg-gray-50 border border-gray-200 p-8 rounded-lg">
                <p id="social-proof-badge" className="font-semibold bg-gray-200 text-gray-800 inline-block px-3 py-1 rounded-full text-sm mb-4">
                    Latest deployment • Fortune 500 pharmaceutical • December 2024
                </p>
                <blockquote id="social-proof-quote" className="text-xl md:text-2xl font-medium text-black">
                    "The team have spoken highly of your product... The ROI was immediate."
                </blockquote>
                <p id="social-proof-author" className="mt-4 text-gray-600">— CEO, Fortune 500 pharmaceutical company</p>
                <p id="social-proof-note" className="mt-6 text-sm text-gray-500">3 more Fortune 500 companies currently in pilot phase.</p>
            </div>
        </div>
    </section>
  );
};

// --- 10. CALL-TO-ACTION SECTION ---
const CTA = () => {
  return (
    <section id="cta-section" className="bg-gray-50 py-20 sm:py-24">
      <div id="cta-container" className="container mx-auto px-6 text-center">
        <h2 id="cta-title" className="text-4xl font-bold text-black">Validated by the industry</h2>
        <p id="cta-subtitle" className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">See how we're accelerating clinical operations for medical device, pharma & CRO teams worldwide.</p>
        <button id="cta-button" className="mt-8 bg-black text-white px-8 py-4 font-semibold hover:bg-gray-800 transition-colors rounded-md text-lg">
          Book your demo slot this week
        </button>
        <p id="cta-note" className="mt-4 text-sm text-gray-500">
            See your document type processed live • Get ROI calculation • Your data stays private
        </p>
      </div>
    </section>
  );
};

// --- 11. FOOTER ---
const Footer = () => {
  const linkSections = {
    "Solutions": ["Clinical affairs", "Clinical investigation", "Regulatory affairs", "Systematic reviews"],
    "Industries": ["Medical device", "Pharmaceutical", "Biotech", "Use cases"],
    "Resources": ["Knowledge base", "Free SR guide", "Templates", "Publications"],
    "Company": ["About", "Team", "Contact", "Privacy policy"],
  };

  return (
    <footer id="main-footer" className="bg-black text-white">
      <div id="footer-container" className="container mx-auto px-6 pt-16 pb-8">
        <div id="footer-content" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div id="footer-company-info" className="lg:col-span-2 mb-8 md:mb-0">
            <h3 id="footer-logo" className="text-2xl font-bold">DeepDocs AI</h3>
            <p id="footer-description" className="mt-4 text-gray-400 max-w-sm">The only AI platform built for clinical affairs compliance. Write systematic reviews in days, not months.</p>
             <button id="footer-demo-button" className="mt-6 bg-white text-black px-5 py-2.5 font-semibold hover:bg-gray-200 transition-colors rounded-md text-sm">
                Book demo
            </button>
          </div>
          {/* Link Sections */}
          {Object.entries(linkSections).map(([title, links]) => (
            <div key={title} id={`footer-section-${title.toLowerCase()}`}>
              <h4 id={`footer-section-title-${title.toLowerCase()}`} className="font-semibold tracking-wider uppercase">{title}</h4>
              <ul id={`footer-links-${title.toLowerCase()}`} className="mt-4 space-y-3">
                {links.map((link, linkIndex) => <li key={link} id={`footer-link-${title.toLowerCase()}-${linkIndex}`}><a href="#" className="text-gray-400 hover:text-white transition-colors">{link}</a></li>)}
              </ul>
            </div>
          ))}
        </div>
        <div id="footer-bottom" className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
          <p id="footer-copyright">© 2025 DeepDocs AI. All rights reserved. Built with revenue, validated by the industry.</p>
          <p id="footer-tagline" className="mt-2">Trusted by medical device, pharma & biotech leaders worldwide</p>
        </div>
      </div>
    </footer>
  );
};

// --- MAIN APP COMPONENT ---
function FullHomepage(props) {
  return (
    <div id="full-homepage-root" className="bg-white font-sans">
      <Header />
      <main id="main-content">
        <Hero />
        <LogoCarousel />
        <Stats />
        <AIFactories />
        <Features />
        <Testimonials />
        <ROICalculator />
        <SocialProof />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default FullHomepage;
